export const componentDefaults = {
"background-full-body": {
image: "",
mobileImage: ""
},
"header-section": {
title: "Title",
subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleTypography: "h2",
subtitleTypography: "subheader-h1",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonTargetDialogId: "",
secondaryButtonId: ""
},
"header-group": {
title: "Title",
subtitle: "Category",
titleTypography: "h2",
subtitleTypography: "subheader-h1",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonTargetDialogId: "",
secondaryButtonId: ""
},
"header-tnc": {
hasCardStyle: false,
items: [
{
title: "Title",
description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleVisible: true,
descriptionVisible: true,
titleId: "",
descriptionId: "",
cardId: "tnc-card-0",
visible: true
}
]
},
"hero-banner-full-image": {
title: "Title",
subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonTargetDialogId: "",
secondaryButtonId: "",
image: "",
mobileImage: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true
},
"footer-omnichannel": {
image: "",
menuColor: "default",
copyrightText: "Copyright © [brand_name] 2026",
availableAtTitle: "Available At",
resourcesTitle: "Follow Us",
socialLinks: [
{ label: '[social-link]', url: '', visible: true, id: '', image: '', imageId: '', linkType: 'url', targetDialogId: '' },
{ label: '[social-link]', url: '', visible: true, id: '', image: '', imageId: '', linkType: 'url', targetDialogId: '' },
{ label: '[social-link]', url: '', visible: true, id: '', image: '', imageId: '', linkType: 'url', targetDialogId: '' }
],
findUsOnLinks: [{
label: "[marketplace-name]",
url: "",
visible: true,
id: "",
image: "",
imageId: "",
linkType: "url",
targetDialogId: ""
},
{
label: "[marketplace-name]",
url: "",
visible: true,
id: "",
image: "",
imageId: "",
linkType: "url",
targetDialogId: ""
},
{
label: "[marketplace-name]",
url: "",
visible: true,
id: "",
image: "",
imageId: "",
linkType: "url",
targetDialogId: ""
}
],
resourceLinks: [{
label: "[legal-link]",
url: "", visible: true,
id: "",
linkType: "url",
targetDialogId: ""
},
{
label: "[legal-link]",
url: "", visible: true,
id: "",
linkType: "url",
targetDialogId: ""
}
]
},
"footer-basic": {
image: "",
menuColor: "default",
copyrightText: "Copyright © [brand_name] 2026",
resourceLinks: [
{ label: '[legal-link]', url: '', visible: true, id: '', linkType: 'url', targetDialogId: '' },
{ label: '[legal-link]', url: '', visible: true, id: '', linkType: 'url', targetDialogId: '' }
],
contactLinks: [
{ label: '[social-link]', url: '', visible: true, id: '', image: '', imageId: '', linkType: 'url', targetDialogId: '' },
{ label: '[social-link]', url: '', visible: true, id: '', image: '', imageId: '', linkType: 'url', targetDialogId: '' }
]
},
"feature-image-left": {
category: "category",
categoryTypography: "subheader-h2",
categoryVisible: true,
title: "Title",
subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleTypography: "h2",
subtitleTypography: "body-regular",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonTargetDialogId: "",
secondaryButtonId: "",
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true
},
"feature-image-top": {
align: "left",
category: "category",
categoryTypography: "subheader-h2",
categoryVisible: true,
title: "Title",
subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleTypography: "h2",
subtitleTypography: "body-regular",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonTargetDialogId: "",
secondaryButtonId: "",
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true
},
"feature-image-right": {
category: "category",
categoryTypography: "subheader-h2",
categoryVisible: true,
title: "Title",
subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
titleTypography: "h2",
subtitleTypography: "body-regular",
titleVisible: true,
subtitleVisible: true,
buttonStyle: "primary",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonId: "",
secondaryButtonText: "Label",
secondaryButtonUrl: "",
secondaryButtonVisible: true,
secondaryButtonLinkType: "url",
secondaryButtonId: "",
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true
},
"feature-column": {
title: "title",
titleVisible: true,
items: [
{
title: "Feature Title",
description: "Feature Description",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonIconLeft: "",
buttonIconRight: "",
buttonTargetDialogId: "",
buttonId: "fc-link-0",
cardId: "fc-card-0",
visible: true,
titleVisible: true,
descriptionVisible: true,
titleId: "",
descriptionId: ""
},
{
title: "Feature Title",
description: "Feature Description",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonIconLeft: "",
buttonIconRight: "",
buttonTargetDialogId: "",
buttonId: "fc-link-1",
cardId: "fc-card-1",
visible: true,
titleVisible: true,
descriptionVisible: true,
titleId: "",
descriptionId: ""
},
{
title: "Feature Title",
description: "Feature Description",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonIconLeft: "",
buttonIconRight: "",
buttonTargetDialogId: "",
buttonId: "fc-link-2",
cardId: "fc-card-2",
visible: true,
titleVisible: true,
descriptionVisible: true,
titleId: "",
descriptionId: ""
}
]
},
"dialog-item-list": {
title: "Title",
description: "Description",
titleVisible: true,
descriptionVisible: true,
image: "",
imageId: "",
imageVisible: true,
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true,
items: Array(8).fill({ label: "Label", image: "", url: "", itemId: "", visible: true, imageAutoplay: true, linkType: "url", targetDialogId: "" })
},
"dialog-basic": {
title: "Title",
description: "Description",
titleVisible: true,
descriptionVisible: true,
image: "",
imageId: "",
imageVisible: true,
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true
},
"dialog-accordion": {
title: "Title",
description: "Description",
titleVisible: true,
descriptionVisible: true,
image: "",
imageId: "",
imageVisible: true,
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true,
items: Array(8).fill({ title: "Accordion Title", content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." })
},
"dialog-form-gen-ai": {
title: "Title",
description: "Description",
titleVisible: true,
descriptionVisible: true,
image: "",
imageId: "",
imageVisible: true,
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true,
successImage: "",
successImageVisible: true,
successTitleVisible: true,
successDescriptionVisible: true,
watermarkSrc: "",
successWatermarkSrc: "",
resultTypeVisible: true,
resultTypeLabel: "Result Type",
resultTypeImageTitle: "Image",
resultTypeImageTitleVisible: true,
resultTypeImageDesc: "the process will take 2-3 min",
resultTypeImageDescVisible: true,
resultTypeVideoTitle: "Video",
resultTypeVideoTitleVisible: true,
resultTypeVideoDesc: "the process will take 4-5 min",
resultTypeVideoDescVisible: true,
marketingConsentLabel: "I agree to receive information about exciting offers, product updates, and other information from [brand_name] and other Wings brands.",
collectionConsentLabel: "I agree to allow Wings to manage my personal data in accordance with the Wings Privacy Policy.",
nameLabel: "Full Name",
whatsappLabel: "WhatsApp Number",
imageUploadLabel: "Upload your image",
imageUploadPlaceholder: "Choose File",
nameVisible: true,
whatsappVisible: true,
imageUploadVisible: true,
marketingConsentVisible: true,
collectionConsentVisible: true,
nameFieldId: "name-field",
whatsappFieldId: "whatsapp-field",
imageUploadFieldId: "image-upload-field",
marketingConsentId: "marketing-consent",
collectionConsentId: "collection-consent",
submitButtonText: "Submit",
submitButtonVariant: "primary",
submitButtonIconLeft: "",
submitButtonIconRight: "",
submitButtonId: "submit-button",
alertVisible: true,
alertType: "info",
alertIcon: "Lightbulb",
alertText: "lorem ipsum"
},
"form-gen-ai-section": {
title: "Title",
description: "Description",
image: "",
imageId: "",
imageVisible: true,
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageAutoplay: true,
successImage: "",
successImageVisible: true,
successTitleVisible: true,
successDescriptionVisible: true,
watermarkSrc: "",
successWatermarkSrc: "",
resultTypeVisible: true,
resultTypeLabel: "Result Type",
resultTypeImageTitle: "Image",
resultTypeImageTitleVisible: true,
resultTypeImageDesc: "the process will take 2-3 min",
resultTypeImageDescVisible: true,
resultTypeVideoTitle: "Video",
resultTypeVideoTitleVisible: true,
resultTypeVideoDesc: "the process will take 4-5 min",
resultTypeVideoDescVisible: true,
marketingConsentLabel: "I agree to receive information about exciting offers, product updates, and other information from [brand_name] and other Wings brands.",
collectionConsentLabel: "I agree to allow Wings to manage my personal data in accordance with the Wings Privacy Policy.",
nameLabel: "Full Name",
whatsappLabel: "WhatsApp Number",
imageUploadLabel: "Upload your image",
imageUploadPlaceholder: "Choose File",
nameVisible: true,
whatsappVisible: true,
imageUploadVisible: true,
marketingConsentVisible: true,
collectionConsentVisible: true,
nameFieldId: "name-field",
whatsappFieldId: "whatsapp-field",
imageUploadFieldId: "image-upload-field",
marketingConsentId: "marketing-consent",
collectionConsentId: "collection-consent",
submitButtonText: "Submit",
submitButtonVariant: "primary",
submitButtonIconLeft: "",
submitButtonIconRight: "",
submitButtonId: "submit-button",
alertVisible: true,
alertType: "info",
alertIcon: "Lightbulb",
alertText: "lorem ipsum"
},
"form-personal-data-section": {
marketingConsentLabel: "I agree to receive information about exciting offers, product updates, and other information from [brand_name] and other Wings brands.",
collectionConsentLabel: "I agree to allow Wings to manage my personal data in accordance with the Wings Privacy Policy.",
interestPromoLabel: "Which Wings promotion do you like most",
imageUploadLabel: "Upload Image",
nameVisible: true,
emailVisible: true,
whatsappVisible: true,
genderVisible: true,
dobVisible: true,
interestPromoVisible: true,
imageUploadVisible: true,
marketingConsentVisible: true,
collectionConsentVisible: true,
nameFieldId: "name-field",
emailFieldId: "email-field",
whatsappFieldId: "whatsapp-field",
genderFieldId: "gender-field",
dobFieldId: "dob-field",
interestPromoFieldId: "interest-promo-field",
imageUploadFieldId: "image-upload-field",
marketingConsentId: "marketing-consent",
collectionConsentId: "collection-consent",
submitButtonText: "Submit",
submitButtonId: "submit-button",
successTitle: "Submission Successful!",
successTitleVisible: true,
successDescription: "Thank you for submitting your details. Your response has been recorded successfully.",
successDescriptionVisible: true,
successImage: "",
successImageId: "success-image",
successImageVisible: true,
successImageUrl: "",
successImageLinkType: "url",
successImageTargetDialogId: "",
successImageEnableAudio: false,
successImageAutoplay: true,
outputProvider: "webhook"
},
"osm-banner": {
title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "",
isSticky: true,
isOverlay: false,
variant: "neutral"
},
"media-16-9": {
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
fullWidth: false,
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true
},
"media-5-4": {
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
fullWidth: false,
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true
},
"media-4-3": {
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
fullWidth: false,
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true
},
"media-21-9": {
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
fullWidth: false,
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true
},
"media-grid-col-3": {
images: Array.from({ length: 6 }, (_, i) => ({
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true,
visible: true,
cardId: `image-${i}`
})),
fullWidth: false,
hasFloatingEffect: false,
aspectRatio: "1-1",
autoScroll: false,
autoScrollEffect: "slide",
marqueeDuration: 60,
marqueeDirection: "rtl",
imageShowStroke: false
},
"media-grid-col-2": {
images: Array.from({ length: 4 }, (_, i) => ({
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true,
visible: true,
cardId: `image-${i}`
})),
fullWidth: false,
hasFloatingEffect: false,
aspectRatio: "1-1",
autoScroll: false,
autoScrollEffect: "slide",
marqueeDuration: 60,
marqueeDirection: "rtl",
imageShowStroke: false
},
"media-grid-col-6": {
images: Array.from({ length: 6 }, (_, i) => ({
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
imageIsPortrait: false,
imageMobileRatio: "",
imageMobileSrc: "",
imageAutoplay: true,
visible: true,
cardId: `image-${i}`
})),
fullWidth: false,
hasFloatingEffect: false,
aspectRatio: "1-1",
autoScroll: false,
autoScrollEffect: "slide",
marqueeDuration: 60,
marqueeDirection: "rtl",
imageShowStroke: false
},
"navigation-center": {
logo: "",
logoVisible: true,
logoId: "",
logoUrl: "",
logoOpenInNewTab: false,
logoLinkType: "url",
logoTargetDialogId: "",
menu1Label: "Menu 1",
menu1Url: "",
menu1LinkType: "url",
menu1TargetDialogId: "",
menu1Id: "",
menu2Label: "Menu 2",
menu2Url: "",
menu2LinkType: "url",
menu2TargetDialogId: "",
menu2Id: "",
menu3Label: "Menu 3",
menu3Url: "",
menu3LinkType: "url",
menu3TargetDialogId: "",
menu3Id: "",
menu4Label: "Menu 4",
menu4Url: "",
menu4LinkType: "url",
menu4TargetDialogId: "",
menu4Id: "",
isSticky: true,
isOverlay: false,
menuColor: "default",
navBackground: "transparent"
},
"navigation-left": {
logo: "",
logoVisible: true,
logoId: "",
logoUrl: "",
logoOpenInNewTab: false,
logoLinkType: "url",
logoTargetDialogId: "",
menu1Label: "Menu 1",
menu1Url: "",
menu1LinkType: "url",
menu1TargetDialogId: "",
menu1Id: "",
menu2Label: "Menu 2",
menu2Url: "",
menu2LinkType: "url",
menu2TargetDialogId: "",
menu2Id: "",
menu3Label: "Menu 3",
menu3Url: "",
menu3LinkType: "url",
menu3TargetDialogId: "",
menu3Id: "",
menu4Label: "Menu 4",
menu4Url: "",
menu4LinkType: "url",
menu4TargetDialogId: "",
menu4Id: "",
isSticky: true,
isOverlay: false,
menuColor: "default",
navBackground: "transparent"
},
"navigation-right": {
logo: "",
logoVisible: true,
logoId: "",
logoUrl: "",
logoOpenInNewTab: false,
logoLinkType: "url",
logoTargetDialogId: "",
menu1Label: "Menu 1",
menu1Url: "",
menu1LinkType: "url",
menu1TargetDialogId: "",
menu1Id: "",
menu2Label: "Menu 2",
menu2Url: "",
menu2LinkType: "url",
menu2TargetDialogId: "",
menu2Id: "",
menu3Label: "Menu 3",
menu3Url: "",
menu3LinkType: "url",
menu3TargetDialogId: "",
menu3Id: "",
menu4Label: "Menu 4",
menu4Url: "",
menu4LinkType: "url",
menu4TargetDialogId: "",
menu4Id: "",
isSticky: true,
isOverlay: false,
menuColor: "default",
navBackground: "transparent"
},
"testimony-landscape": {
testimonies: Array(4).fill({
name: "people name",
role: "role",
description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
avatar: "",
avatarUrl: "",
avatarLinkType: "url",
avatarTargetDialogId: "",
imageVisible: true,
avatarVisible: true,
imageAutoplay: true,
avatarAutoplay: true,
cardId: "",
visible: true
}),
fullWidth: false,
autoScroll: true,
autoScrollEffect: 'slide',
marqueeDuration: 120,
marqueeDirection: 'rtl',
imageShowStroke: false
},
"testimony-portrait": {
testimonies: Array(4).fill({
name: "people name",
role: "role",
description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
image: "",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
avatar: "",
avatarUrl: "",
avatarLinkType: "url",
avatarTargetDialogId: "",
imageVisible: true,
avatarVisible: true,
imageAutoplay: true,
avatarAutoplay: true,
cardId: "",
visible: true
}),
fullWidth: false,
autoScroll: true,
autoScrollEffect: 'slide',
marqueeDuration: 120,
marqueeDirection: 'rtl',
imageShowStroke: false
},
"scroll-group": {
image: "", // Desktop Background
mobileImage: "", // Mobile Background
imageIsPortrait: false,
imageMobileRatio: "",
scrollEffect: "none", // 'none' | 'parallax' | 'sticky' | 'stacked'
enableBlur: false,
transparentNextSection: false,
scrim: "none", // 'none' | 'dark' | 'brand'
components: [] // Nested components
},
"spacing-small": {},
"spacing-medium": {},
"spacing-large": {},
"gallery-product-gallery": {
showTabs: true,
showActionButtons: true,
imageShowStroke: false,
categories: [
{ id: "cat-1", label: "Category 1", visible: true },
{ id: "cat-2", label: "Category 2", visible: true },
{ id: "cat-3", label: "Category 3", visible: true },
{ id: "cat-4", label: "Category 4", visible: true }
],
products: [
...Array(4).fill().map((_, i) => ({
name: "Product 1",
description: "Description 1",
image: "", imageUrl: "", imageLinkType: "url", imageTargetDialogId: "", imageVisible: true, imageAutoplay: true,
buttonUrl: "", buttonLinkType: "url", buttonTargetDialogId: "", buttonVisible: true, buttonId: "",
categoryId: "cat-1", cardId: `p1-${i}`, visible: true
})),
...Array(4).fill().map((_, i) => ({
name: "Product 2",
description: "Description 2",
image: "", imageUrl: "", imageLinkType: "url", imageTargetDialogId: "", imageVisible: true,
buttonUrl: "", buttonLinkType: "url", buttonTargetDialogId: "", buttonVisible: true, buttonId: "",
categoryId: "cat-2", cardId: `p2-${i}`, visible: true
})),
...Array(4).fill().map((_, i) => ({
name: "Product 3",
description: "Description 3",
image: "", imageUrl: "", imageLinkType: "url", imageTargetDialogId: "", imageVisible: true,
buttonUrl: "", buttonLinkType: "url", buttonTargetDialogId: "", buttonVisible: true, buttonId: "",
categoryId: "cat-3", cardId: `p3-${i}`, visible: true
})),
...Array(4).fill().map((_, i) => ({
name: "Product 4",
description: "Description 4",
image: "", imageUrl: "", imageLinkType: "url", imageTargetDialogId: "", imageVisible: true,
buttonUrl: "", buttonLinkType: "url", buttonTargetDialogId: "", buttonVisible: true, buttonId: "",
categoryId: "cat-4", cardId: `p4-${i}`, visible: true
}))
]
},
"social-bridge-tiktok": {
videos: Array(4).fill({
videoUrl: "",
name: "",
description: "",
thumbnailUrl: "",
fetchedUrl: "",
cardId: "",
visible: true
}),
fullWidth: false,
allowAutoplay: true,
},
"gallery-strip": {
items: Array(6).fill({
title: "Gallery Item Title",
hashtag: "#hashtag",
image: "",
imageId: "",
imageAutoplay: true,
showStroke: true,
cardId: "",
visible: true,
url: "",
linkType: "url",
targetDialogId: "",
}),
autoScroll: true,
autoScrollEffect: 'slide',
marqueeDuration: 120,
marqueeDirection: 'rtl',
imageOnly: false,
isCompact: false,
aspectRatio: "9-16",
imageShowStroke: false
},
"gallery-slider": {
items: [
{
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "slider-image-0",
cardId: "slider-card-0",
visible: true
},
{
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "slider-image-1",
cardId: "slider-card-1",
visible: true
}
],
autoScroll: false,
autoScrollEffect: 'slide',
},
"image-carousel": {
items: [
{
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "carousel-image-0",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
title: "title 1",
description: "description 1",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "carousel-btn-0",
cardId: "carousel-card-0",
visible: true
},
{
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "carousel-image-1",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
title: "title 2",
description: "description 2",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "carousel-btn-1",
cardId: "carousel-card-1",
visible: true
},
{
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "carousel-image-2",
imageUrl: "",
imageLinkType: "url",
imageTargetDialogId: "",
title: "title 3",
description: "description 3",
buttonText: "Label",
buttonUrl: "",
buttonVisible: true,
buttonLinkType: "url",
buttonTargetDialogId: "",
buttonId: "carousel-btn-2",
cardId: "carousel-card-2",
visible: true
}
],
autoScroll: false,
autoScrollEffect: "slide"
},
"floating-action-button": {
image: "https://space.lunaaar.site/assets-lunar/placeholder.svg",
imageId: "",
imageVisible: true,
linkType: "url",
url: "",
targetDialogId: "",
imageShowStroke: false,
isOverlay: true
}
};